import { PUBLIC_BACKEND_BASE as BACKEND_BASE } from "@/hooks/usePublicMenu";

export function resolveMedia(url) {
  if (!url || typeof url !== "string" || url.trim() === "") return "";
  if (url.startsWith("https://customer-assets") || url.startsWith("https://images.unsplash") || url.startsWith("http://res.cloudinary")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_BASE}${url}`;
  const apiMatch = url.match(/\/api\/(uploads|restaurant|cloud-file)\/.+/);
  if (apiMatch) return `${BACKEND_BASE}${apiMatch[0]}`;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return url;
}
